import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { Loader, Segment, Header, Button, Form, Icon, Message } from 'semantic-ui-react';
import moment from 'moment';

import { fetchAcademicYears, fetchAllAcademicYears, fetchFaculties } from '../Lookups/util';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';
import { FiltersOnStyle } from '../Professor/ProfessorInputGrades/css';
import NonCycleStudentsTable from './NonCycleStudentTable';

const OTHER_ACTIVITIES_VALUE = 'OTHER_ACTIVITIES';

export const filterStudents = (state) => {
    let filteredStudents = state.students;

    if (state.selectedAcademicYearId) {
        filteredStudents = filteredStudents.filter(student => student.academicYear.id === state.selectedAcademicYearId);
    }
    if (state.selectedFacultyId) {
        filteredStudents = filteredStudents.filter(student => {
            return state.studentOrganizationalUnits.some(
                unit => unit.nonCycleStudent.id === student.id &&
                    unit.organizationalUnit.id === state.selectedFacultyId
            );
        });
    }
    if (state.selectedCourseId) {
        if (state.selectedCourseId === OTHER_ACTIVITIES_VALUE) {
            filteredStudents = filteredStudents.filter(student =>
                state.studentOUCourses.some(
                    unit => unit.nonCycleStudentId === student.id &&
                        unit.isActivity === true &&
                        unit.courseStudyProgramId === null
                )
            );
        } else {
            filteredStudents = filteredStudents.filter(student =>
                state.studentOUCourses.some(
                    unit => unit.nonCycleStudentId === student.id &&
                        unit.courseBasicId === state.selectedCourseId
                )
            );
        }
    }
    if (state.selectedNonCycleStudyProgramTypeId) {
        filteredStudents = filteredStudents.filter(student =>
            student.nonCycleProgram &&
            student.nonCycleProgram.nonCycleStudyProgramType &&
            student.nonCycleProgram.nonCycleStudyProgramType.id === state.selectedNonCycleStudyProgramTypeId
        );
    }

    return {
        filteredStudents,
        // @formatter:off
        excelData: [{
            columns: [
                { title: 'Ime', width: { wpx: 110 } },
                { title: 'Prezime', width: { wpx: 110 } },
                { title: 'JMBG', width: { wpx: 140 } },
                { title: 'Spol', width: { wpx: 90 } },
                { title: 'Datum rođenja', width: { wpx: 120 } },
                { title: 'Zemlja rođenja', width: { wpx: 150 } },
                { title: 'Mjesto rođenja', width: { wpx: 150 } },
                { title: 'Email', width: { wpx: 200 } },
                { title: 'Akademska godina', width: { wpx: 130 } },
                { title: 'Naziv programa', width: { wpx: 260 } },
                { title: 'Tip programa', width: { wpx: 200 } },
                { title: 'Datum početka', width: { wpx: 120 } },
                { title: 'Datum završetka', width: { wpx: 120 } },
                { title: 'Trajanje (mj.)', width: { wpx: 110 } },
                { title: 'ECTS', width: { wpx: 80 } },
                { title: 'Datum diplomiranja', width: { wpx: 140 } },
                { title: 'Datum odustajanja', width: { wpx: 140 } },
            ],
            data: filteredStudents.map(student => ([
                { value: student.firstName || '' },
                { value: student.lastName || '' },
                { value: student.jmbg || '' },
                { value: student.gender ? student.gender.name : '' },
                { value: student.dateOfBirth ? moment(student.dateOfBirth).format('D. M. YYYY.') : '' },
                { value: student.birthCountry ? student.birthCountry.name : '' },
                { value: student.birthPlaceName || '' },
                { value: student.email || '' },
                { value: student.academicYear ? student.academicYear.name : '' },
                { value: student.nonCycleProgram ? student.nonCycleProgram.programName || '' : '' },
                { value: student.nonCycleProgram && student.nonCycleProgram.nonCycleStudyProgramType ? student.nonCycleProgram.nonCycleStudyProgramType.name : '' },
                { value: student.nonCycleProgram && student.nonCycleProgram.dateFrom ? moment(student.nonCycleProgram.dateFrom).format('D. M. YYYY.') : '' },
                { value: student.nonCycleProgram && student.nonCycleProgram.dateTo ? moment(student.nonCycleProgram.dateTo).format('D. M. YYYY.') : '' },
                { value: student.nonCycleProgram ? student.nonCycleProgram.programDurationMonths || '' : '' },
                { value: student.nonCycleProgram ? student.nonCycleProgram.maxEcts || '' : '' },
                { value: student.graduationDate ? moment(student.graduationDate).format('D. M. YYYY.') : '' },
                { value: student.dropoutDate ? moment(student.dropoutDate).format('D. M. YYYY.') : '' },
            ]))
        }]
        // @formatter:on
    };
};

class NonCycleStudentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            students: [],
            filteredStudents: [],
            loading: true,
            studentOrganizationalUnits: [],
            studentOUCourses: [],
            academicYears: [],
            faculties: [],
            courses: [],
            nonCycleStudyProgramTypes: [],
            nonGradedWarnings: new Map(),

            selectedAcademicYearId: null,
            selectedFacultyId: null,
            selectedCourseId: null,
            selectedNonCycleStudyProgramTypeId: null,
            searchText: '',

            excelData: [],

            deletingRowId: null,
            saving: false,
        };

        this.fetchInitialData = this.fetchInitialData.bind(this);
        this.getResults = this.getResults.bind(this);
        this.handleSearchTextChange = this.handleSearchTextChange.bind(this);
        this.filterStudents = this.filterStudents.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);

    }

    componentDidMount() {
        this.fetchInitialData();
    }

    fetchInitialData() {
        this.setState({ loading: true });

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isProfessor = localStorageRole.slice(0, 8) === 'Profesor';

        const requests = [
            axios.get('/non-cycle-student'), // TODO: fetch students by academic year
            fetchFaculties(),
            fetchAcademicYears(),
            axios.get('/non-cycle-study-program-types'),
        ];

        if (isAdmin) {
            requests.push(axios.get('/non-cycle-student-ou'));
        }

        if (isProfessor) {
            requests.push(axios.get('/non-cycle-student-ou-course/grading'));
        }

        Promise.all(requests)
            .then((responses) => {
                const nonCycleStudentsResponse = responses[0];
                const facultiesResponse = responses[1];
                const academicYearsResponse = responses[2];
                const nonCycleStudyProgramTypesResponse = responses[3];
                let studentOrganizationalUnitsResponse = { data: [] };
                let studentOUCoursesResponse = { data: [] };
                if (isAdmin) {
                    studentOrganizationalUnitsResponse = responses[4];
                }
                if (isProfessor) {
                    studentOUCoursesResponse = responses[4];
                }

                const courseOptions = Array.from(
                    new Map(
                        studentOUCoursesResponse.data
                            .filter((item => !item.isActivity))
                            .map(item => [item.courseBasicId, {
                                key: item.courseBasicId,
                                text: item.courseName,
                                value: item.courseBasicId,
                            }])
                    ).values()
                );

                if (studentOUCoursesResponse.data.some(item => item.isActivity)) {
                    courseOptions.unshift({
                        key: OTHER_ACTIVITIES_VALUE,
                        text: <FormattedMessage id="externalStudent.otherActivityTypes"/>,
                        value: OTHER_ACTIVITIES_VALUE,
                    });
                }

                const nonGradedWarnings = new Map();
                studentOUCoursesResponse.data.forEach(item => {
                    if (item.markKey === 'nonp' || !item.markKey) {
                        if (!nonGradedWarnings.has(item.nonCycleStudentId)) {
                            nonGradedWarnings.set(item.nonCycleStudentId, []);
                        }

                        nonGradedWarnings
                            .get(item.nonCycleStudentId)
                            .push(item.isActivity ? item.activityName : item.courseName);
                    }
                });
                // console.log(nonGradedWarnings);

                const sortedStudents = nonCycleStudentsResponse.data.sort((a, b) => {
                    const dateA = a.nonCycleProgram && a.nonCycleProgram.dateTo ? new Date(a.nonCycleProgram.dateTo) : new Date(0);
                    const dateB = b.nonCycleProgram && b.nonCycleProgram.dateTo ? new Date(b.nonCycleProgram.dateTo) : new Date(0);
                    return dateB - dateA;
                });
                this.setState({
                        students: sortedStudents,
                        filteredStudents: sortedStudents,
                        studentOrganizationalUnits: studentOrganizationalUnitsResponse.data,
                        studentOUCourses: studentOUCoursesResponse.data,
                        courses: courseOptions,
                        faculties: facultiesResponse.data,
                        academicYears: academicYearsResponse.data.sort((a, b) => b.startYear - a.startYear),
                        nonCycleStudyProgramTypes: nonCycleStudyProgramTypesResponse.data,
                        loading: false,
                        selectedAcademicYearId: academicYearsResponse.data.length > 0 ? academicYearsResponse.data[0].id : null,
                        nonGradedWarnings,
                    }, () => {
                        this.filterStudents();
                    }
                );
            })
            .catch((error) => {
                toast(<FormattedMessage id="externalStudent.toast.errorFetchingData"/>);
                this.setState({ loading: false });
            });
    }

    getResults = (results) => {
        if (results.length === 0 && this.state.searchText.trim() === '') {
            this.filterStudents();
        } else {
            this.setState({
                filteredStudents: results,
                currentPage: 1
            });
        }
    };

    handleSearchTextChange = (text) => {
        this.setState({ searchText: text });
    };

    filterStudents = () => {
        const {
            filteredStudents,
            excelData
        } = filterStudents(this.state);

        this.setState({
            filteredStudents,
            excelData
        });
    };

    handleCancelClick = () => {
        this.setState({ deletingRowId: null });
    };

    handleDeleteClick = (studentId) => {
        this.setState({ deletingRowId: studentId });
    };

    handleConfirmClick = () => {
        this.setState({ saving: true });
        axios.delete(`/non-cycle-student/${this.state.deletingRowId}`)
            .then((response) => {
                toast(<FormattedMessage id="externalStudent.toast.studentSuccessfullyDeleted"/>);
                this.setState((prevState) => ({
                    students: prevState.students.filter(student => student.id !== prevState.deletingRowId),
                    deletingRowId: null,
                    saving: false,
                }), () => {
                    this.filterStudents();
                });
            })
            .catch((error) => {
                this.setState({ saving: false });
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
            });
    };

    render() {
        const {
            students,
            filteredStudents,
            excelData,
            loading,
            academicYears,
            faculties,
            courses,
            nonCycleStudyProgramTypes,
            selectedAcademicYearId,
            selectedFacultyId,
            selectedCourseId,
            selectedNonCycleStudyProgramTypeId,
            deletingRowId,
            saving,
            nonGradedWarnings,
        } = this.state;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isProfessor = localStorageRole.slice(0, 8) === 'Profesor';

        return (
            <div>
                <h2>{<FormattedMessage id="externalStudent.nonCycleStudyProgram"/>}</h2>
                <Segment.Group raised>
                    <Segment>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Header as="h3" style={{ margin: 0 }}>
                                {<FormattedMessage id="externalStudent.nonCycleStudyProgramStudents"/>}
                            </Header>
                            {(/*isAdmin || */isStudentService) && (
                                <Button
                                    as={Link}
                                    to={{ pathname: '/neciklicni-studij/kreiranje' }}
                                    primary
                                    color="green"
                                    disabled={loading}
                                    loading={loading}
                                    floated="right"
                                    icon
                                    labelPosition="right"
                                    size="small"
                                    style={FiltersOnStyle}
                                ><Icon className="add"/>
                                    <FormattedMessage id="externalStudent.createNonCycleStudyProgramStudent"/>
                                </Button>)}
                        </div>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Select
                                    search
                                    fluid
                                    label={<FormattedMessage id="externalStudent.academicYear"/>}
                                    placeholder={<FormattedMessage id="externalStudent.selectAcademicYear"/>}
                                    // clearable={true}
                                    options={academicYears.map(el => ({
                                        key: el.id,
                                        text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                                        value: el.id
                                    }))}
                                    value={selectedAcademicYearId}
                                    onChange={(e, { value }) =>
                                        this.setState({ selectedAcademicYearId: value }, this.filterStudents)
                                    }
                                />
                                <Form.Select
                                    search
                                    fluid
                                    label={<FormattedMessage id="externalStudent.nonCycleStudyProgramType"/>}
                                    placeholder={<FormattedMessage
                                        id="externalStudent.selectNonCycleStudyProgramType"/>}
                                    clearable={true}
                                    options={nonCycleStudyProgramTypes.map(el => ({
                                        key: el.id,
                                        text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                                        value: el.id
                                    }))}
                                    value={selectedNonCycleStudyProgramTypeId}
                                    onChange={(e, { value }) =>
                                        this.setState({ selectedNonCycleStudyProgramTypeId: value }, this.filterStudents)
                                    }
                                />
                                {(isAdmin) && (
                                    <Form.Select
                                        search
                                        loading={loading}
                                        fluid
                                        label={<FormattedMessage id="externalStudent.faculty"/>}
                                        placeholder={<FormattedMessage id="externalStudent.selectFaculty"/>}
                                        clearable={true}
                                        options={faculties.map(el => ({
                                            key: el.id,
                                            text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                                            value: el.id
                                        }))}
                                        value={selectedFacultyId}
                                        onChange={(e, { value }) =>
                                            this.setState({ selectedFacultyId: value }, this.filterStudents)
                                        }
                                    />)}
                                {(isProfessor) && (
                                    <Form.Select
                                        search
                                        loading={loading}
                                        fluid
                                        label={<FormattedMessage id="externalStudent.course"/>}
                                        placeholder={<FormattedMessage id="externalStudent.selectCourse"/>}
                                        clearable={true}
                                        options={courses}
                                        value={selectedCourseId}
                                        onChange={(e, { value }) =>
                                            this.setState({ selectedCourseId: value }, this.filterStudents)
                                        }
                                    />)}
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        {loading ? (
                            <Loader active inline="centered"/>
                        ) : (
                            <Fragment>
                                <Message>
                                    U tabeli su prikazani svi studenti na necikličnim studijskim programima.
                                    Klikom na dugme "Profil studenta" otvara se stranica sa detaljnim informacijama o
                                    studentu.
                                </Message>
                                <NonCycleStudentsTable
                                    students={students}
                                    filteredStudents={filteredStudents}
                                    excelData={excelData}

                                    getResults={this.getResults}
                                    handleSearchTextChange={this.handleSearchTextChange}

                                    deletingRowId={deletingRowId}
                                    saving={saving}

                                    handleDeleteClick={this.handleDeleteClick}
                                    handleConfirmClick={this.handleConfirmClick}
                                    handleCancelClick={this.handleCancelClick}

                                    isAdmin={isAdmin}
                                    isStudentService={isStudentService}

                                    nonGradedWarnings={nonGradedWarnings}
                                />
                            </Fragment>
                        )}
                    </Segment>
                    <ToastContainer position="top-right" hideProgressBar={true}/>
                </Segment.Group>
            </div>
        );
    }
}

export default NonCycleStudentList;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentList.js